module.exports = __webpack_public_path__ + "static/media/izjava.346b12bf.docx";